module.exports = __webpack_public_path__ + "static/media/skill4_neg_en.066dc2df.txt";